"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _reactSwipeable = require("react-swipeable");
var _TileLine = _interopRequireDefault(require("./TileLine"));
const TitleText = _styled.default.div(_ref => {
  let {
    theme
  } = _ref;
  return {
    fontSize: theme.fontSizes.xLarge,
    fontWeight: theme.fontWeights.semiBold
  };
});
const TileWrapper = _styled.default.div({
  display: 'flex',
  height: '100%',
  marginBottom: '16px',
  marginTop: '16px'
});
const TileLineWrapper = _styled.default.div({
  display: 'flex'
});
const CarouselWrapper = _styled.default.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  width: 150vw;

  .slide-out-left {
    animation-fill-mode: forwards;
    transform: translateX(-100%);
    transition: transform 0.25s ease-out;
  }

  .slide-out-right {
    animation-fill-mode: forwards;
    transform: translateX(100%);
    transition: transform 0.25s ease-out;
  }
`;
const IndividualTileWrap = _styled.default.div({
  animationDuration: '0.25s'
});

/**
 * Infinite scrolling carousel with clickable tiles
 * that users can swipe through in mobile view. Swiping ability
 * requires at least 3 tiles, otherwise the tiles will be
 * displayed normally.
 *
 * @title title for the carousel that will appear above it
 */
const Carousel = _ref2 => {
  let {
    children,
    title
  } = _ref2;
  // right === -1, left === 1
  let swipeDirection = 0;
  // an array to keep track of the index of the 3 tiles that are displayed in the carousel
  // default is last tile, first tile, second tile
  const [tileIndexArray, setTileIndexArray] = (0, _react.useState)([_react.Children.count(children) - 1, 0, 1]);
  const updateIndex = indexChange => {
    let tempTileArray = tileIndexArray;
    tempTileArray = tempTileArray.map(tileIndex => {
      let newTileIndex = tileIndex + indexChange;
      if (newTileIndex < 0) {
        newTileIndex = _react.Children.count(children) - 1;
      } else if (newTileIndex >= _react.Children.count(children)) {
        newTileIndex = 0;
      }
      return newTileIndex;
    });
    setTileIndexArray(tempTileArray);
  };

  /*
   * Function taken from https://animate.style/#documentation
   */
  const animateCSS = (element, animation) =>
  // We create a Promise and return it
  new Promise(resolve => {
    const node = document.querySelector(element);
    node.classList.add(animation);

    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd(event) {
      event.stopPropagation();
      resolve('Animation ended');
      updateIndex(swipeDirection);
    }
    node.addEventListener('transitionend', handleAnimationEnd, {
      once: true
    });
  });
  const handlers = (0, _reactSwipeable.useSwipeable)({
    onSwiped: eventData => {
      const swipeDirString = eventData.dir.toLowerCase();
      swipeDirection = swipeDirString === 'right' ? -1 : 1;
      tileIndexArray.forEach(tileIndex => animateCSS(`.tile-wrapper-${tileIndex}`, `slide-out-${swipeDirString}`));
      animateCSS('.tile-wrapper-start', `slide-out-${swipeDirString}`);
      animateCSS('.tile-wrapper-end', `slide-out-${swipeDirString}`);
    }
  });

  // Remove animation class from the tiles. This has to be done in an effect otherwise there's a flash.
  (0, _react.useEffect)(() => {
    if (_react.Children.count(children) > 2) {
      tileIndexArray.forEach(tileIndex => {
        const node = document.querySelector(`.tile-wrapper-${tileIndex}`);
        node === null || node === void 0 ? void 0 : node.classList.remove('slide-out-right');
        node === null || node === void 0 ? void 0 : node.classList.remove('slide-out-left');
      });
      const start = document.querySelector('.tile-wrapper-start');
      const end = document.querySelector('.tile-wrapper-end');
      start === null || start === void 0 ? void 0 : start.classList.remove('slide-out-right');
      end === null || end === void 0 ? void 0 : end.classList.remove('slide-out-right');
      start === null || start === void 0 ? void 0 : start.classList.remove('slide-out-left');
      end === null || end === void 0 ? void 0 : end.classList.remove('slide-out-left');
    }
  }, [children, tileIndexArray]);

  // append tiles to the beginning and end of the 3 that are shown so the slide animation shows the next tiles.
  const appendExtraTiles = () => {
    const endTileIndex = tileIndexArray[2] + 1;
    const startTileIndex = tileIndexArray[0] - 1;
    const startTileTernary = startTileIndex < 0 ? _react.Children.count(children) - 1 : startTileIndex;
    const endTileTernary = endTileIndex >= _react.Children.count(children) ? 0 : endTileIndex;
    return [/*#__PURE__*/_react.default.createElement(IndividualTileWrap, {
      className: "tile-wrapper-start",
      key: "start-tile"
    }, /*#__PURE__*/(0, _react.cloneElement)(children === null || children === void 0 ? void 0 : children[startTileTernary], {
      inFocus: false
    })), ...tileIndexArray.map(tileIndex => /*#__PURE__*/_react.default.createElement(IndividualTileWrap, {
      className: `tile-wrapper-${tileIndex}`,
      key: tileIndex
    }, /*#__PURE__*/(0, _react.cloneElement)(children === null || children === void 0 ? void 0 : children[tileIndex], {
      inFocus: tileIndex === tileIndexArray[1]
    }))), /*#__PURE__*/_react.default.createElement(IndividualTileWrap, {
      className: "tile-wrapper-end",
      key: "end-tile"
    }, /*#__PURE__*/(0, _react.cloneElement)(children === null || children === void 0 ? void 0 : children[endTileTernary], {
      inFocus: false
    }))];
  };
  return /*#__PURE__*/_react.default.createElement(CarouselWrapper, null, /*#__PURE__*/_react.default.createElement(TitleText, null, title), _react.Children.count(children) > 2 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(TileWrapper, handlers, appendExtraTiles()), /*#__PURE__*/_react.default.createElement(TileLineWrapper, null, _react.Children.map(children, (tile, index) => /*#__PURE__*/_react.default.createElement(_TileLine.default, {
    isHighlighted: index === tileIndexArray[1],
    key: `tileLine-${tile}`
  })))) : /*#__PURE__*/_react.default.createElement(TileWrapper, null, children));
};
var _default = exports.default = Carousel;